import { useState, useEffect } from 'react';

import { bucketFor } from '../components/layout/shellMetrics';

// FE-08 — Görünüm genişliğinin KOVASINI ('xs'|'sm'|'md'|'lg') izler.
//
// Ham genişliği değil KOVAYI durumda tutmak bilinçli: `Layout` uygulamanın
// bütün ağacını sarmalıyor. Ham genişlik tutulsaydı pencere yeniden
// boyutlandırılırken her piksel tüm ürünü yeniden render ederdi. Kova bir dize
// olduğundan React aynı değerde render'ı atlar — sürükleyerek boyutlandırmada
// yeniden render sayısı sıfırdan üçe iner (xs→sm→md→lg), binlerce değil.
//
// `matchMedia` KULLANILMIYOR: jsdom onu hiç tanımlamıyor (bkz.
// test-utils/domRender.js'in `mockMatchMedia` yardımcısı ve SmartStatCard.js'in
// `!!window.matchMedia` koruması). `window.innerWidth` + `resize` her iki
// ortamda da çalışır ve testin görünüm genişliğini kurgulamasına izin verir.

function readWidth() {
  if (typeof window === 'undefined') return 1280;
  return window.innerWidth || 1280;
}

export default function useLayoutBucket() {
  const [bucket, setBucket] = useState(() => bucketFor(readWidth()));

  useEffect(() => {
    let frame = 0;

    const apply = () => {
      frame = 0;
      setBucket(bucketFor(readWidth()));
    };

    const onResize = () => {
      if (frame) return;
      if (typeof window.requestAnimationFrame === 'function') {
        frame = window.requestAnimationFrame(apply);
      } else {
        apply();
      }
    };

    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    // Bağlanma anında bir kez okur: sunucu/ilk render ile gerçek pencere
    // arasındaki farkı kapatır. Değer aynıysa React render'ı atlar.
    apply();

    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
      if (frame && typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(frame);
      }
    };
  }, []);

  return bucket;
}
